// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"23789":"e66901851f277422","59888":"3bd01ed01989a07c"}[chunkId] + ".css";
};